import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { IActivity, ICreateActivityRequest, ICreateActivityResponse } from 'src/services/api/activities';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { CREATE_ACTIVITY_PATH } from 'src/services/api/activities/constants';


export const useCreateActivity = () => {
    const queryClient = useQueryClient();

    return useMutation<
    IActivity,
    IStandardErrorResponse,
    ICreateActivityRequest
    >(
        async (payload) => {
            const res = await apiClient(CREATE_ACTIVITY_PATH, {
                method: 'post',
                // include the time in the request (similar to creating showings)
                // send action type
                json: payload,
            }).json<ICreateActivityResponse>();

            return res.activity;
        }, {
            onSuccess: () => {
                // creating an activity can also advance the streak, so refetch the whole payload
                queryClient.invalidateQueries([queryKeys.userStreaks]);
            },
        });
};